import { Routes, Route } from 'react-router-dom'
import { PlayerProvider } from './lib/player'
import Home from './routes/Home'
import PaperSong from './routes/PaperSong'
import About from './routes/About'
import PlayBar from './components/PlayBar'
import LyricsPanel from './components/LyricsPanel'

function App() {
  return (
    <PlayerProvider>
      <div className="min-h-screen lg:h-screen lg:flex">
        {/* Main content area */}
        <div className="flex-1 lg:overflow-hidden">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            {/* NeurIPS URL format: /virtual/2025/poster/117515 */}
            <Route path="/virtual/2025/:type/:id" element={<PaperSong />} />
            {/* With location: /virtual/2025/loc/san-diego/poster/117515 */}
            <Route path="/virtual/2025/loc/:location/:type/:id" element={<PaperSong />} />
          </Routes>
        </div>
        {/* Global Lyrics sidebar - shows on all pages (desktop only) */}
        <LyricsPanel />
      </div>
      {/* Global PlayBar - shows on all pages */}
      <PlayBar />
    </PlayerProvider>
  )
}

export default App
